export default "__VITE_ASSET__JS0SYsT4__"